import React from 'react';
import PagePreview from './preview/PagePreview';
import ProductPreview from './preview/ProductPreview';
import BannerPreview from './preview/BannerPreview';
import HomepageSectionPreview from './preview/HomepageSectionPreview';
import NavigationPreview from './preview/NavigationPreview';
import FooterPreview from './preview/FooterPreview';
import SettingsPreview from './preview/SettingsPreview';
import SeoPreview from './preview/SeoPreview';
import {
  PageBlockPreview,
  CategoryPreview,
  BrandPreview,
  StorePreview,
  ArticlePreview,
  FaqPreview,
  TestimonialPreview,
} from './preview/StandardPreviews';

export default function CMSPreviewRenderer({
  section,
  form = {},
  categoryOptions = [],
  navigationOptions = [],
  viewport = 'desktop',
}) {
  switch (section) {
    case 'pages':
      return <PagePreview form={form} />;
    case 'page-blocks':
      return <PageBlockPreview form={form} />;
    case 'categories':
      return <CategoryPreview form={form} />;
    case 'products':
      return <ProductPreview form={form} categoryOptions={categoryOptions} />;
    case 'banners':
      return <BannerPreview form={form} viewport={viewport} />;
    case 'homepage-sections':
      return <HomepageSectionPreview form={form} />;
    case 'brands':
      return <BrandPreview form={form} />;
    case 'stores':
      return <StorePreview form={form} />;
    case 'articles':
      return <ArticlePreview form={form} />;
    case 'faqs':
      return <FaqPreview form={form} />;
    case 'testimonials':
      return <TestimonialPreview form={form} />;
    case 'navigation':
      return <NavigationPreview form={form} navigationOptions={navigationOptions} />;
    case 'footer':
      return <FooterPreview form={form} />;
    case 'settings':
      return <SettingsPreview form={form} />;
    case 'seo':
      return <SeoPreview form={form} />;
    default:
      return (
        <div className="p-8 text-center text-slate-400 text-xs italic">
          No live preview available for this section.
        </div>
      );
  }
}
